const Ajax = (args, datas, viewmodel) => {
  var proxy = cb.rest.DynamicProxy.create({
    ensure: {
      url: args.cSvcUrl,
      method: args.cHttpMethod
    }
  });
  var params = {
    billnum: "pc_product",
    action: args.cAction,
    data: JSON.stringify(datas)
  }
  proxy.ensure(params, function (err, result) {
    if (err) {
      cb.utils.alert(err.message, 'error');
      return;
    }
    let { count, failCount, messages, sucessCount } = result;
    if (sucessCount) {
      cb.utils.alert(args.cShowCaption + '成功' + sucessCount + '条', 'success');
    }
    if (failCount !== undefined) {
      messages.forEach(v => {
        cb.utils.alert(v, 'warning');
      })
      viewmodel.execute('back');
      return false
    }
    cb.utils.alert("操作成功", 'success');
    viewmodel.execute('back');
  });
}
const findMax = (arr) => {
  let i;
  let length = arr.length;
  let hash = []; //使用哈希数组
  for (i = 0; i < length; i++) {
    if (!hash[arr[i]]) hash[arr[i]] = 1; //没有初始化的数组元素为undefined，undefined++为NaN
    else hash[arr[i]]++;
  }
  let max = 0; //最多的次数
  let maxV; //出现最多的元素
  let second = 0; //第二多的次数
  let secondV; //出现第二多的元素
  hash.forEach(function (item, index) { //forEach函数会跳过空元素
    if (item > max) {
      second = max;
      secondV = maxV;
      max = item;
      maxV = index; //用索引来保存原数组的值
    } else if (item > second) {
      second = item;
      secondV = index;
    }
  });
  return { max, maxV, second, secondV };
}
const formatter = (viewmodel) => {
  let gridModel = viewmodel.getGridModel();
  gridModel.on('beforeLoad', function (data) {
    if (data.condition.isDistinct) {
      data.isDistinct = true;
    } else {
      if (typeof data.isDistinct === 'boolean') {
        delete data.isDistinct
      }
    }
    delete data.condition.isDistinct
  });
  // 商品档案 - 标签 格式化
  gridModel.setColumnState('productTag', 'formatter', (rowInfo, rowData) => {
    return {
      formatterKey: 'ProductLabel',
      props: {
        rowInfo,
        rowData
      }
    }
  })
  // 商品档案 - 商品名称 格式化
  gridModel.setColumnState('name', 'formatter', (rowInfo, rowData) => {
    return {
      formatterKey: 'ProductBrand',
      props: {
        rowInfo,
        rowData
      }
    }
  });
  // 商品档案 - 价格 格式化
  gridModel.setColumnState('productPrice', 'formatter', (rowInfo, rowData) => {
    return {
      formatterKey: 'ProductPrice',
      props: {
        rowInfo,
        rowData
      }
    }
  })
  // 商品档案 - 状态 格式化
  gridModel.setColumnState('productStatus', 'formatter', (rowInfo, rowData) => {
    return {
      formatterKey: 'ProductState',
      props: {
        rowInfo,
        rowData
      }
    }
  })
};
(function seturl() {
  var proxy = cb.rest.DynamicProxy.create({
    ensure: {
      url: '/productbill/product/QRCodeUrl',
      method: 'GET'
    }
  });
  proxy.ensure({}, function (err, result) {
    if (err) {
      cb.utils.alert(err.message, 'error');
      localStorage.removeItem('mall_url', result.MallDomain);
      localStorage.removeItem('wid', result.wid);
      return;
    }
    localStorage.setItem('mall_url', result.MallDomain);
    localStorage.setItem('wid', result.wid);
  });
})();
module.exports = {
  Ajax: Ajax,
  formatter: formatter,
  findMax: findMax
}


// WEBPACK FOOTER //
// ./src/client/business/PC/common_product_list_pro.js